// NavBar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import logo from '../logo512.png'
import './NavBar.css'; 
import { app } from '../FirebaseConfig'
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';

const NavBar = () => {
    const navigate = useNavigate();
    const [localAuthState, setLocalAuthState] = useState(false);
    const auth = getAuth(app);
    const DebounceDueTime = 200
    var debounceTimeout;
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (debounceTimeout)
                clearTimeout(debounceTimeout);
        
            debounceTimeout = setTimeout(() =>
            {
                debounceTimeout = null;
        
                handleAuthStateChanged(user);
            }, DebounceDueTime);
        })
      }, [auth])

    const handleAuthStateChanged = (user) => {
        if(user){
            console.log("Logged In")
            setLocalAuthState(true);
        }
        else {
            console.log('Not Logged In')
            setLocalAuthState(false);
        }
    }

    const handleLogout = () => {
        signOut(auth);
        navigate('/login')
    }

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className="navbar-links">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/about" className="nav-link">About</Link>
        {localAuthState ? (
          <button onClick={handleLogout} className="nav-link-button">Sign Out</button>
        ) : (
          <Link to="/login" className="nav-link">Login</Link>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
